module.exports = __webpack_public_path__ + "static/img/nykart-bg5-2x.a1f7a57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nykart-bg5-2x.jpg
// module id = 2s8E
// module chunks = 0